import { NeoModel, ModelBase, Attributes, Misc, Validation, Rules } from '@singularsystems/neo-core';
import RawGenericTransactionLookup from '../Lookups/RawGenericTransactionLookup';
import { TextConstants } from '../../../../Common/TextConstants';

@NeoModel
export default class UpdateCashTransactionCommand extends ModelBase {
    public staticServiceProviderFileGroupingID: number | null = null;

    public newStaticInstrumentID : number | null = null;

    public newStaticEventID : number | null = null;

    public newEventName: string = "";

    public IsSentInd: boolean = false;

    public newStaticCurrencyId : number | null = null;

    public newInstrumentDescription: string = "";

    public isExcludedInd: boolean = false;

    public isReversalInd: boolean = false;

    @Attributes.Float()
    public priceOverride: number | null = null;

    public updatePriceToBookCostInd: boolean = false;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public newTime: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public newDateEvent:  Date | null = null;

    public newTimeString: string | null = null;

    public setClientAccountIDToNull: boolean = false;

    @Rules.Required(TextConstants.GeneralText.BatchNotesRequired)
    public updateNotes: string  = "";

    public transactions: RawGenericTransactionLookup[] = [];

    public transactionType: number = 2;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.newStaticCurrencyId !== null && c.newStaticCurrencyId > 0 && 
            (c.updatePriceToBookCostInd || (c.priceOverride !== null && c.priceOverride > 0)), "The currency and book cost cannot be simultaneously updated.");

        rules.failWhen(c => c.newStaticCurrencyId !== null && c.newStaticCurrencyId > 0 &&
            (c.priceOverride !== null && c.priceOverride > 0), "The currency and price cannot be simultaneously updated.");
        
    }
}